@for (banner of banners(); track banner.id) {
    <div class="banner" [ngClass]="banner.config.type">
        <div class="icon">
            <mat-icon [svgIcon]="banner.config.icon"></mat-icon>
        </div>
        <div class="content">
            @if (banner.title) {
                <p class="link">{{ banner.title }}</p>
            }
            <p>{{ banner.subtitle }}</p>
        </div>
        @if (banner.dismissible) {
            <button class="close" aria-label="Dismiss notification" type="button" (click)="close(banner.id)">
                <mat-icon svgIcon="ico_close"></mat-icon>
            </button>
        }
    </div>
}
